<template>
	<div class="site-offline-container">
		<form @submit.prevent="submit" novalidate>
		<div class="input-holder">
			<FloatLabel>
				<Password inputId="OfflinePassword" v-model="request.Password" :feedback="false" />
				<label for="OfflinePassword">Login</label>
			</FloatLabel>			
			<small class="p-error" v-if="form.Password.$error">{{ form.Password.$errors[0].$message }}</small>
			<button type="submit" class="offline-button" :loading="isSubmitting"></button>
		</div>
		<div v-if="!validPassword" class="p-error">Invalid password.</div>
	</form>
	</div>
</template>
<script lang="ts" setup>
	import type { ApiResult } from '@/types/ApiResult';
	import useVuelidate from '@vuelidate/core';
	import { helpers, required } from '@vuelidate/validators';
	import 'intl-tel-input/styles';
	import { computed, ref } from 'vue';
	import wretch from 'wretch';
	import { SiteOfflineBypassFormRequestModel } from './types';
	import { FloatLabel, Password } from 'primevue';

	const isSubmitting = ref<boolean>(false);
	const isSubmitted = ref<boolean>(false);
	const validPassword = ref<boolean>(true);

	const rules = computed<Partial<Record<keyof SiteOfflineBypassFormRequestModel, unknown>>>(() => ({
		Password: { required: helpers.withMessage('Required field', required) },
	}));

	const request = ref<SiteOfflineBypassFormRequestModel>(new SiteOfflineBypassFormRequestModel());
	const form = useVuelidate<SiteOfflineBypassFormRequestModel>(rules, request);

	async function submit() {
		if (!(await form.value.$validate())) {
			return;
		}

		try {
			isSubmitting.value = true;

			const resp = await wretch('/api/site-offline/bypass').post(request.value).json<ApiResult<object>>();
			if (resp.successful) {
				validPassword.value = true;
				isSubmitted.value = true;
				window.location.href = '/';
			} else {
				validPassword.value = false;
			}
		} finally {
			isSubmitting.value = false;
		}
	}
</script>
